module.exports = __webpack_public_path__ + "img/DNARepair-CRC_10X_WTA.2d55eca1.png";